/** @module Enums */ /** typedoc */
var SessionFlagsEnum;
(function (SessionFlagsEnum) {
    SessionFlagsEnum["canFullyMigrateToFusebill"] = "canFullyMigrateToFusebill";
    SessionFlagsEnum["isEmailConfirmed"] = "isEmailConfirmed";
    SessionFlagsEnum["isFreeMasteringUser"] = "isFreeMasteringUser";
    SessionFlagsEnum["isFreeDistributionUser"] = "isFreeDistributionUser";
    SessionFlagsEnum["hasMastered"] = "hasMastered";
    SessionFlagsEnum["hasApprovedReleases"] = "hasApprovedReleases";
    SessionFlagsEnum["hasPromoted"] = "hasPromoted";
    SessionFlagsEnum["hasShared"] = "hasShared";
    SessionFlagsEnum["isReferred"] = "isReferred";
    SessionFlagsEnum["hasAlbums"] = "hasAlbums";
    SessionFlagsEnum["hasReferences"] = "hasReferences";
})(SessionFlagsEnum || (SessionFlagsEnum = {}));

export { SessionFlagsEnum };
